import React from 'react'
import { CitationCopy } from '@chegg-wt/core/types/copy'
import { maybePluralizeWithNum, maybePluralize } from '@chegg-wt/core/utils/language'
import { CITATION_LIST_TITLE_SINGLE } from '@chegg-wt/core/constants/citations'
import { AppLink } from '@chegg-wt/core/components/AppLink'
import { AppRoute } from '@chegg-wt/core/types/core'
import * as Styled from './styled'

export const citationCopy: CitationCopy = {
  createCitation: 'Create citation',
  emptyCitationList: `Your ${CITATION_LIST_TITLE_SINGLE} is empty`,
  emptyCitationCreateLink: 'Get started by creating a citation',
  copyAllCitation: 'Copy all',
  exportAllCitation: 'Export all',
  sortBy: 'Sort by',
  generalErrorText: 'An error occurred',
  toastMessages: {
    copyCitations: (count: number) =>
      `${maybePluralizeWithNum(count, 'citation', 'citations')} copied!`,
    copyAllCitations: 'All citations copied!',
    deleteCitations: (count: number) =>
      `${maybePluralizeWithNum(count, 'citation', 'citations')} deleted!`,
    downloadCitations: `${CITATION_LIST_TITLE_SINGLE} downloaded!`,
    moveCitations: (count: number, projectName: string, route: AppRoute) => {
      const citationMessage = `Your ${maybePluralize(
        count,
        'citation is',
        'citations are'
      )} now in ${projectName}.`
      const seeCitationMessage = `See ${maybePluralize(count, 'citation', 'citations')}`
      return (
        <Styled.MoveCitationsCopyContainer>
          <Styled.MoveCitationsCopyText>{citationMessage}</Styled.MoveCitationsCopyText>{' '}
          <AppLink route={route}>
            <Styled.MoveCitationsCopyLink title={seeCitationMessage}>
              {seeCitationMessage}
            </Styled.MoveCitationsCopyLink>
          </AppLink>
        </Styled.MoveCitationsCopyContainer>
      )
    },
  },
}
